<template>
  <div class="whatsapp-connect-modern">
    <div class="connect-container">
      <!-- Main Content Card -->
      <div class="content-card">
        <div class="card-header">
          <div class="header-content">
            <h3 class="card-title">
              <i class="fab fa-whatsapp title-icon"></i>
              Conectar WhatsApp {{ string_type }}
            </h3>
            <p class="card-subtitle">
              Configure sua conexão para envio de notificações
            </p>
          </div>
          <div class="status-indicator">
            <span class="status-label">Status:</span>
            <span :class="['status-badge', statusClass]">
              <i
                :class="[
                  'fas',
                  connected ? 'fa-check-circle' : 'fa-times-circle',
                ]"
              ></i>
              {{ statusText }}
            </span>
          </div>
        </div>

        <div class="card-content">
          <!-- Phone Number Section -->
          <div class="phone-section">
            <label for="phone_number" class="section-label">
              <i class="fas fa-phone mr-2"></i>
              Número de Telefone
            </label>

            <div class="input-group">
              <select v-model="ddd" class="country-select">
                <option value="+55">+55</option>
              </select>

              <input
                v-model="phone_number"
                v-mask="'(##) # ####-####'"
                id="phone_number"
                type="text"
                class="phone-input"
                placeholder="(00) 0 0000-0000"
                :disabled="connected"
              />
              <v-btn
                v-if="permission('write', 'whatsapp_report_medicine')"
                @click="savePhoneNumber"
                class="btn-save-phone"
                :disabled="connected"
              >
                <i class="fas fa-save mr-2"></i>
                Salvar
              </v-btn>
            </div>
          </div>

          <!-- Actions Section -->
          <div
            class="actions-section"
            v-if="permission('write', 'whatsapp_report_medicine')"
          >
            <v-btn
              v-if="!connected"
              class="btn-connect"
              :class="{ 'btn-disabled': !saved_phone_number }"
              @click="$bvModal.show('viewQrCode')"
              :disabled="!saved_phone_number"
            >
              <i class="fas fa-qrcode mr-2"></i>
              Gerar QR Code
            </v-btn>

            <v-btn
              v-if="connected"
              class="btn-disconnect"
              @click="disconnectInstance"
              :disabled="disconnecting"
            >
              <i class="fas fa-sign-out-alt mr-2"></i>
              {{ disconnecting ? "Desconectando..." : "Desconectar WhatsApp" }}
            </v-btn>
          </div>
        </div>
      </div>

      <!-- Tutorial Card -->
      <div class="tutorial-card">
        <div class="tutorial-header">
          <i class="fas fa-book tutorial-icon"></i>
          <h4 class="tutorial-title">Como Conectar</h4>
        </div>

        <div class="tutorial-content">
          <div class="tutorial-steps">
            <div class="step-item">
              <div class="step-number">1</div>
              <div class="step-text">
                Cadastre seu número de telefone celular e clique em
                <strong>Salvar</strong>
              </div>
            </div>

            <div class="step-item">
              <div class="step-number">2</div>
              <div class="step-text">
                Clique no botão <strong>"Gerar QR Code"</strong> para gerar o
                código de conexão
              </div>
            </div>

            <div class="step-item">
              <div class="step-number">3</div>
              <div class="step-text">
                Escaneie o QR Code com seu WhatsApp e aguarde a confirmação
              </div>
            </div>

            <div class="step-item">
              <div class="step-number">4</div>
              <div class="step-text">
                Verifique o status. Se estiver como
                <strong>"Conectado"</strong>, está tudo certo!
              </div>
            </div>
          </div>

          <div class="tutorial-tip">
            <i class="fas fa-lightbulb tip-icon"></i>
            <p class="tip-text">
              Para desconectar, clique no botão "Desconectar WhatsApp" que
              aparecerá quando estiver conectado.
            </p>
          </div>
        </div>
      </div>
    </div>

    <ModalViewQrCode
      :rest_home_id="rest_home_id"
      :type="type"
      :phone_number="phone_number"
      @connect="listInstance"
    />
  </div>
</template>

<script>
import ModalViewQrCode from "./ModalViewQrCode";
import toast from "../../lib/ToastNotification";
import api from "../../services/api";
import permission from "../../lib/permission";

export default {
  name: "WhatsAppConnect",

  components: {
    ModalViewQrCode,
  },

  props: {
    type: String,
    rest_home_id: Number,
  },

  data() {
    return {
      loading: false,

      ddd: "+55",

      phone_number: "",

      string_type: "",

      connected: false,

      disconnecting: false,

      saved_phone_number: false,

      errors: [],
    };
  },

  watch: {
    phone_number() {
      if (this.phone_number.length != 0 && this.phone_number.length != 16) {
        this.saved_phone_number = false;
      }
    },
  },

  async mounted() {
    await this.listInstance();

    await this.getPhoneNumber();

    if (this.type == "FINANCE") {
      this.string_type = "Financeiro";
    } else if (this.type == "REPORT_CARE") {
      this.string_type = "Cuidados";
    } else if (this.type == "REPORT_MEDICINE") {
      this.string_type = "Medicamentos";
    }
  },

  computed: {
    statusText() {
      return this.connected ? "Conectado" : "Desconectado";
    },

    statusClass() {
      return this.connected ? "status-connected" : "status-disconnected";
    },
  },

  methods: {
    permission,

    async savePhoneNumber() {
      try {
        this.loading = true;

        let { type, phone_number } = this;

        let params = { phone_number, type };

        const response = await api.post("/whatsapp/save-phone-number", params);

        const { error, message } = response.data;

        if (!error) {
          if (!phone_number) {
            this.saved_phone_number = false;
          } else {
            this.saved_phone_number = true;
          }

          toast(message, "success");
        } else {
          toast(message, "error");
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async getPhoneNumber() {
      try {
        this.loading = true;

        let { type } = this;

        let params = { type };

        const response = await api.get("/whatsapp/get-phone-number", {
          params,
        });

        const { phone_number } = response.data;

        this.phone_number = phone_number;

        if (this.phone_number) {
          this.saved_phone_number = true;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.error(error);
      }
    },

    async listInstance() {
      try {
        this.loading = true;

        let { type, rest_home_id } = this;

        let params = {
          instanceName: `SISTEMA_CLIN_${type}_${rest_home_id}`,
          type,
        };

        const response = await api.get("/whatsapp/list-instance", { params });
        const { connected } = response.data;

        this.connected = connected;
        this.loading = false;
      } catch (error) {
        this.loading = false;
        console.log(error);
      }
    },

    async disconnectInstance() {
      try {
        this.disconnecting = true;
        this.loading = true;

        let { type, rest_home_id } = this;
        let params = {
          type,
          instanceName: `SISTEMA_CLIN_${type}_${rest_home_id}`,
        };

        const response = await api.post(
          "/whatsapp/disconnect-instance",
          params
        );
        const { error, message } = response.data;

        if (!error) {
          toast(message, "success");
          this.listInstance();
        } else {
          toast(message, "error");
        }

        this.loading = false;
        this.disconnecting = false;
      } catch (error) {
        this.disconnecting = false;
        this.loading = false;
        console.log(error);
      }
    },
  },
};
</script>

<style scoped>
.whatsapp-connect-modern {
  padding: 24px 0;
}

.connect-container {
  display: grid;
  grid-template-columns: 1fr 400px;
  gap: 24px;
  max-width: 1200px;
  margin: 0 auto;
}

/* Content Card */
.content-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
}

.card-header {
  background: linear-gradient(135deg, #dcfce7 0%, #bbf7d0 100%);
  padding: 24px;
  border-bottom: 1px solid #86efac;
}

.header-content {
  margin-bottom: 16px;
}

.card-title {
  font-size: 20px;
  font-weight: 600;
  color: #14532d;
  margin: 0 0 4px 0;
  display: flex;
  align-items: center;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.title-icon {
  color: #16a34a;
  margin-right: 8px;
  font-size: 20px;
}

.card-subtitle {
  color: #166534;
  font-size: 14px;
  margin: 0;
  font-weight: 500;
  margin-left: 10px;
}

.status-indicator {
  display: flex;
  align-items: center;
  gap: 12px;
}

.status-label {
  font-size: 14px;
  font-weight: 600;
  color: #166534;
}

.status-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 16px;
  border-radius: 20px;
  font-size: 13px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  transition: all 0.3s ease;
}

.status-connected {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3);
}

.status-disconnected {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3);
}

.card-content {
  padding: 32px 24px;
}

/* Phone Section */
.phone-section {
  margin-bottom: 32px;
}

.section-label {
  display: flex;
  align-items: center;
  font-size: 14px;
  font-weight: 600;
  color: #374151;
  margin-bottom: 12px;
}

.input-group {
  display: flex;
  gap: 0;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.05);
}

.country-select {
  border: 2px solid #e5e7eb;
  border-right: none;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #374151;
  background: white;
  cursor: pointer;
  transition: all 0.3s ease;
  border-radius: 12px 0 0 12px;
  min-width: 80px;
}

.country-select:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.phone-input {
  flex: 1;
  border: 2px solid #e5e7eb;
  border-left: none;
  border-right: none;
  padding: 12px 16px;
  font-size: 14px;
  font-weight: 500;
  color: #1e293b;
  transition: all 0.3s ease;
}

.phone-input:focus {
  outline: none;
  border-color: #10b981;
  box-shadow: 0 0 0 3px rgba(16, 185, 129, 0.1);
}

.phone-input::placeholder {
  color: #9ca3af;
}

.btn-save-phone {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  height: 50px !important;
  border: none !important;
  padding: 12px 24px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  font-size: 12px !important;
  box-shadow: 0 2px 8px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
  border-radius: 0 12px 12px 0 !important;
}

.btn-save-phone:hover {
  box-shadow: 0 4px 12px rgba(16, 185, 129, 0.4) !important;
}

/* Actions Section */
.actions-section {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.btn-connect {
  background: linear-gradient(135deg, #10b981 0%, #059669 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 16px 32px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  font-size: 14px !important;
  box-shadow: 0 4px 15px rgba(16, 185, 129, 0.3) !important;
  transition: all 0.3s ease !important;
  width: 100% !important;
}

.btn-connect:hover:not(.btn-disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(16, 185, 129, 0.4) !important;
}

.btn-disconnect {
  background: linear-gradient(135deg, #ef4444 0%, #dc2626 100%) !important;
  color: white !important;
  border: none !important;
  border-radius: 12px !important;
  padding: 16px 32px !important;
  font-weight: 600 !important;
  text-transform: uppercase !important;
  letter-spacing: 0.5px !important;
  font-size: 14px !important;
  box-shadow: 0 4px 15px rgba(239, 68, 68, 0.3) !important;
  transition: all 0.3s ease !important;
  width: 100% !important;
}

.btn-disconnect:hover:not(:disabled) {
  transform: translateY(-2px) !important;
  box-shadow: 0 6px 20px rgba(239, 68, 68, 0.4) !important;
}

.btn-disabled {
  opacity: 0.5 !important;
  cursor: not-allowed !important;
  transform: none !important;
}

.btn-disconnect:disabled {
  opacity: 0.7 !important;
  cursor: not-allowed !important;
}

/* Tutorial Card */
.tutorial-card {
  background: white;
  border-radius: 16px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.08);
  border: 1px solid rgba(255, 255, 255, 0.2);
  overflow: hidden;
  height: fit-content;
  position: sticky;
  top: 24px;
}

.tutorial-header {
  background: linear-gradient(135deg, #e0e7ff 0%, #c7d2fe 100%);
  padding: 20px 24px;
  border-bottom: 1px solid #818cf8;
  display: flex;
  align-items: center;
  gap: 12px;
}

.tutorial-icon {
  color: #4338ca;
  font-size: 20px;
}

.tutorial-title {
  font-size: 18px;
  font-weight: 600;
  color: #3730a3;
  margin: 0;
  font-family: "WorkSans-SemiBold", sans-serif;
}

.tutorial-content {
  padding: 24px;
}

.tutorial-steps {
  display: flex;
  flex-direction: column;
  gap: 20px;
  margin-bottom: 24px;
}

.step-item {
  display: flex;
  gap: 16px;
  align-items: flex-start;
}

.step-number {
  width: 32px;
  height: 32px;
  border-radius: 50%;
  background: linear-gradient(135deg, #4338ca 0%, #3730a3 100%);
  color: white;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 14px;
  flex-shrink: 0;
  box-shadow: 0 4px 12px rgba(67, 56, 202, 0.3);
}

.step-text {
  flex: 1;
  font-size: 14px;
  color: #374151;
  line-height: 1.6;
  padding-top: 4px;
}

.step-text strong {
  color: #1e293b;
  font-weight: 600;
}

.tutorial-tip {
  background: linear-gradient(135deg, #fef3c7 0%, #fed7aa 100%);
  border: 1px solid #f59e0b;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  gap: 12px;
  align-items: flex-start;
}

.tip-icon {
  color: #d97706;
  font-size: 18px;
  margin-top: 2px;
  flex-shrink: 0;
}

.tip-text {
  flex: 1;
  font-size: 13px;
  color: #92400e;
  line-height: 1.5;
  margin: 0;
}

/* Responsive Design */
@media (max-width: 1024px) {
  .connect-container {
    grid-template-columns: 1fr;
    gap: 24px;
  }

  .tutorial-card {
    position: static;
  }
}

@media (max-width: 768px) {
  .whatsapp-connect-modern {
    padding: 16px 0;
  }

  .card-header {
    padding: 20px 16px;
  }

  .card-content {
    padding: 24px 16px;
  }

  .input-group {
    flex-direction: column;
    border-radius: 12px;
  }

  .country-select,
  .phone-input,
  .btn-save-phone {
    border: 2px solid #e5e7eb !important;
    border-radius: 12px !important;
  }

  .tutorial-content {
    padding: 20px 16px;
  }

  .step-item {
    gap: 12px;
  }

  .step-number {
    width: 28px;
    height: 28px;
    font-size: 13px;
  }
}

@media (max-width: 480px) {
  .card-title {
    font-size: 18px;
    flex-direction: column;
    gap: 4px;
    align-items: flex-start;
  }

  .status-indicator {
    flex-direction: column;
    align-items: flex-start;
    gap: 8px;
  }

  .btn-connect,
  .btn-disconnect {
    padding: 14px 24px !important;
    font-size: 13px !important;
  }
}
</style>